
import { WorldCountry } from '../types';

export const netherlandsData: WorldCountry = {
  code: 'NL',
  name: 'Netherlands',
  slug: 'netherlands',
  population: 17440000,
  topCities: [
    { name: 'Amsterdam', slug: 'amsterdam-netherlands', population: 1158000 },
    { name: 'Rotterdam', slug: 'rotterdam-netherlands', population: 735000 },
    { name: 'The Hague', slug: 'the-hague-netherlands', population: 690000 },
    { name: 'Utrecht', slug: 'utrecht-netherlands', population: 580000 },
    { name: 'Eindhoven', slug: 'eindhoven-netherlands', population: 440000 },
    { name: 'Groningen', slug: 'groningen-netherlands', population: 240000 },
    { name: 'Tilburg', slug: 'tilburg-netherlands', population: 230000 },
    { name: 'Almere', slug: 'almere-netherlands', population: 220000 },
    { name: 'Breda', slug: 'breda-netherlands', population: 185000 },
    { name: 'Nijmegen', slug: 'nijmegen-netherlands', population: 180000 },
    { name: 'Apeldoorn', slug: 'apeldoorn-netherlands', population: 165000 },
    { name: 'Haarlem', slug: 'haarlem-netherlands', population: 162000 },
    { name: 'Arnhem', slug: 'arnhem-netherlands', population: 160000 },
    { name: 'Zaanstad', slug: 'zaanstad-netherlands', population: 157000 },
    { name: 'Haarlemmermeer', slug: 'haarlemmermeer-netherlands', population: 156000 },
    { name: 'Amersfoort', slug: 'amersfoort-netherlands', population: 155000 },
    { name: 'Enschede', slug: 'enschede-netherlands', population: 158000 },
    { name: 'Zwolle', slug: 'zwolle-netherlands', population: 131000 },
    { name: 'Leiden', slug: 'leiden-netherlands', population: 125000 },
    { name: 'Maastricht', slug: 'maastricht-netherlands', population: 122000 },
    { name: 'Dordrecht', slug: 'dordrecht-netherlands', population: 119000 },
    { name: 'Alphen aan den Rijn', slug: 'alphen-aan-den-rijn-netherlands', population: 112000 },
    { name: 'Westland', slug: 'westland-netherlands', population: 110000 },
    { name: 'Leeuwarden', slug: 'leeuwarden-netherlands', population: 109000 },
    { name: 'Alkmaar', slug: 'alkmaar-netherlands', population: 109000 },
    { name: 'Emmen', slug: 'emmen-netherlands', population: 107000 },
    { name: 'Venlo', slug: 'venlo-netherlands', population: 102000 },
    { name: 'Deventer', slug: 'deventer-netherlands', population: 100000 },
    { name: 'Delft', slug: 'delft-netherlands', population: 103000 },
    { name: 'Sittard-Geleen', slug: 'sittard-geleen-netherlands', population: 91000 },
    
    // Expansión: 70 ciudades adicionales para llegar a 100 total
    { name: 'Roosendaal', slug: 'roosendaal-netherlands', population: 77000 },
    { name: 'Purmerend', slug: 'purmerend-netherlands', population: 81000 },
    { name: 'Schiedam', slug: 'schiedam-netherlands', population: 78000 },
    { name: 'Lelystad', slug: 'lelystad-netherlands', population: 78000 },
    { name: 'Lisse', slug: 'lisse-netherlands', population: 23000 },
    { name: 'Spijkenisse', slug: 'spijkenisse-netherlands', population: 74000 },
    { name: 'Hilversum', slug: 'hilversum-netherlands', population: 92000 },
    { name: 'Gouda', slug: 'gouda-netherlands', population: 73000 },
    { name: 'Ede', slug: 'ede-netherlands', population: 118000 },
    { name: 'Hoorn', slug: 'hoorn-netherlands', population: 73000 },
    { name: 'Vlaardingen', slug: 'vlaardingen-netherlands', population: 73000 },
    { name: 'Almelo', slug: 'almelo-netherlands', population: 73000 },
    { name: 'Hengelo', slug: 'hengelo-netherlands', population: 81000 },
    { name: 'Capelle aan den IJssel', slug: 'capelle-aan-den-ijssel-netherlands', population: 67000 },
    { name: 'Nieuwegein', slug: 'nieuwegein-netherlands', population: 64000 },
    { name: 'Assen', slug: 'assen-netherlands', population: 68000 },
    { name: 'Veenendaal', slug: 'veenendaal-netherlands', population: 66000 },
    { name: 'Helmond', slug: 'helmond-netherlands', population: 92000 },
    { name: 'Den Helder', slug: 'den-helder-netherlands', population: 56000 },
    { name: 'Hoofddorp', slug: 'hoofddorp-netherlands', population: 76000 },
    { name: 'Leidschendam-Voorburg', slug: 'leidschendam-voorburg-netherlands', population: 76000 },
    { name: 'Noordwijk', slug: 'noordwijk-netherlands', population: 43000 },
    { name: 'Ridderkerk', slug: 'ridderkerk-netherlands', population: 46000 },
    { name: 'Meppel', slug: 'meppel-netherlands', population: 34000 },
    { name: 'Katwijk', slug: 'katwijk-netherlands', population: 65000 },
    { name: 'Zeist', slug: 'zeist-netherlands', population: 64000 },
    { name: 'Oosterhout', slug: 'oosterhout-netherlands', population: 56000 },
    { name: 'Zoetermeer', slug: 'zoetermeer-netherlands', population: 125000 },
    { name: 'Doetinchem', slug: 'doetinchem-netherlands', population: 58000 },
    { name: 'Alphen', slug: 'alphen-netherlands', population: 111000 },
    { name: 'Middelburg', slug: 'middelburg-netherlands', population: 49000 },
    { name: 'Harderwijk', slug: 'harderwijk-netherlands', population: 48000 },
    { name: 'Kampen', slug: 'kampen-netherlands', population: 54000 },
    { name: 'Woerden', slug: 'woerden-netherlands', population: 53000 },
    { name: 'Barneveld', slug: 'barneveld-netherlands', population: 59000 },
    { name: 'Huizen', slug: 'huizen-netherlands', population: 42000 },
    { name: 'Hardenberg', slug: 'hardenberg-netherlands', population: 61000 },
    { name: 'Smallingerland', slug: 'smallingerland-netherlands', population: 56000 },
    { name: 'Wijchen', slug: 'wijchen-netherlands', population: 41000 },
    { name: 'Wassenaar', slug: 'wassenaar-netherlands', population: 26000 },
    { name: 'Beverwijk', slug: 'beverwijk-netherlands', population: 42000 },
    { name: 'IJsselstein', slug: 'ijsselstein-netherlands', population: 34000 },
    { name: 'Uithoorn', slug: 'uithoorn-netherlands', population: 30000 },
    { name: 'Heerhugowaard', slug: 'heerhugowaard-netherlands', population: 57000 },
    { name: 'Lansingerland', slug: 'lansingerland-netherlands', population: 63000 },
    { name: 'Castricum', slug: 'castricum-netherlands', population: 36000 },
    { name: 'Amstelveen', slug: 'amstelveen-netherlands', population: 91000 },
    { name: 'Velsen', slug: 'velsen-netherlands', population: 68000 },
    { name: 'Bergen op Zoom', slug: 'bergen-op-zoom-netherlands', population: 67000 },
    { name: 'Krimpen aan den IJssel', slug: 'krimpen-aan-den-ijssel-netherlands', population: 29000 },
    { name: 'Rheden', slug: 'rheden-netherlands', population: 43000 },
    { name: 'Druten', slug: 'druten-netherlands', population: 19000 },
    { name: 'Waalwijk', slug: 'waalwijk-netherlands', population: 48000 },
    { name: 'Gilze en Rijen', slug: 'gilze-en-rijen-netherlands', population: 27000 },
    { name: 'Best', slug: 'best-netherlands', population: 30000 },
    { name: 'Heusden', slug: 'heusden-netherlands', population: 45000 },
    { name: 'Coevorden', slug: 'coevorden-netherlands', population: 36000 },
    { name: 'Oldenzaal', slug: 'oldenzaal-netherlands', population: 32000 },
    { name: 'Losser', slug: 'losser-netherlands', population: 22000 },
    { name: 'Aalten', slug: 'aalten-netherlands', population: 27000 },
    { name: 'Twenterand', slug: 'twenterand-netherlands', population: 34000 },
    { name: 'Dinkelland', slug: 'dinkelland-netherlands', population: 26000 },
    { name: 'Tubbergen', slug: 'tubbergen-netherlands', population: 21000 },
    { name: 'Wierden', slug: 'wierden-netherlands', population: 24000 },
    { name: 'Hellendoorn', slug: 'hellendoorn-netherlands', population: 36000 },
    { name: 'Dalfsen', slug: 'dalfsen-netherlands', population: 29000 },
    { name: 'Ommen', slug: 'ommen-netherlands', population: 18000 },
    { name: 'Staphorst', slug: 'staphorst-netherlands', population: 17000 },
    { name: 'Zwartewaterland', slug: 'zwartewaterland-netherlands', population: 23000 },
    { name: 'Hattem', slug: 'hattem-netherlands', population: 12000 },
    { name: 'Heerde', slug: 'heerde-netherlands', population: 19000 },
    { name: 'Elburg', slug: 'elburg-netherlands', population: 23000 }
  ]
};
